var map = {
	"./Alex-Bordei.png": 9771,
	"./Alexandra-Loch.png": 2550,
	"./Alexandru-Jurca.png": 217,
	"./Andrei-Boceanu.png": 712,
	"./Andrei-Zorila.png": 8954,
	"./Dragus-Claudiu.png": 8904,
	"./Francisc-Radoi.png": 8469,
	"./Hamza-A-Malik.png": 1117,
	"./Kostas-Tzoumpas.png": 5249,
	"./Leandro-Marcarian.png": 3676,
	"./Marean-Bogdan.png": 5958,
	"./Oliviu-Jurjica.png": 1996,
	"./Radu-Birta.png": 389,
	"./Robert-Raut.png": 392,
	"./Todo-Razvan.png": 679,
	"./Vasile-Draghici.png": 8037,
	"./Vijit.png": 1345
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8057;